import { Companion_instance3g2kzoy08jm6r as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import {
  serializerodflzzf6s3fp as serializer,
  serializer1hu9wv9at41ww as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer1tw0a8bv7lkga as serializer_2,
} from '../builtins/BuiltinSerializers.mjs';
import { InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor } from './InlineClassDescriptor.mjs';
import {
  _ULong___get_data__impl__fggpzb35t7vg7og3i8u as _ULong___get_data__impl__fggpzb,
  ULong3f9k7s38t3rfp as ULong,
  _ULong___init__impl__c78o9k3fkiaf1q5xsf7 as _ULong___init__impl__c78o9k,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IntCompanionObject_instanceru1css19onx6 as IntCompanionObject_instance,
  ByteCompanionObject_instance3kkatsq6s1rq7 as ByteCompanionObject_instance,
  ShortCompanionObject_instance28ym5go6niq9r as ShortCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  _UInt___get_data__impl__f0vqqw18g8a2o14g87q as _UInt___get_data__impl__f0vqqw,
  UInt1hthisrv6cndi as UInt,
  _UInt___init__impl__l7qpdl2rn8hu5x5mgv2 as _UInt___init__impl__l7qpdl,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UByte___get_data__impl__jof9qryxuf3cmdpzyk as _UByte___get_data__impl__jof9qr,
  UBytep4j7r1t64gz1 as UByte,
  _UByte___init__impl__g9hnc430zp6cgd9f0jq as _UByte___init__impl__g9hnc4,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___get_data__impl__g02451joe1vsk2vach as _UShort___get_data__impl__g0245,
  UShort26xnqty60t7le as UShort,
  _UShort___init__impl__jigrne1zu56ujvuii2n as _UShort___init__impl__jigrne,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ULongSerializerClass;
function ULongSerializer() {
  if (ULongSerializerClass === VOID) {
    class $ {
      constructor() {
        ULongSerializer_instance = this;
        this.b27_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer(Companion_instance));
      }
      h1m() {
        return this.b27_1;
      }
      c27(encoder, value) {
        var tmp = encoder.f1s(this.b27_1);
        // Inline function 'kotlin.ULong.toLong' call
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
        tmp.z1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.c27(encoder, value instanceof ULong() ? value.xu_1 : THROW_CCE());
      }
      d27(decoder) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.v1q(this.b27_1).p1q();
        return _ULong___init__impl__c78o9k(this_0);
      }
      j1m(decoder) {
        return new (ULong())(this.d27(decoder));
      }
    }
    initMetadataForObject($, 'ULongSerializer', VOID, VOID, [KSerializer()]);
    ULongSerializerClass = $;
  }
  return ULongSerializerClass;
}
var ULongSerializer_instance;
function ULongSerializer_getInstance() {
  if (ULongSerializer_instance === VOID)
    new (ULongSerializer())();
  return ULongSerializer_instance;
}
var UIntSerializerClass;
function UIntSerializer() {
  if (UIntSerializerClass === VOID) {
    class $ {
      constructor() {
        UIntSerializer_instance = this;
        this.e27_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_0(IntCompanionObject_instance));
      }
      h1m() {
        return this.e27_1;
      }
      f27(encoder, value) {
        var tmp = encoder.f1s(this.e27_1);
        // Inline function 'kotlin.UInt.toInt' call
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
        tmp.y1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.f27(encoder, value instanceof UInt() ? value.mu_1 : THROW_CCE());
      }
      g27(decoder) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.v1q(this.e27_1).o1q();
        return _UInt___init__impl__l7qpdl(this_0);
      }
      j1m(decoder) {
        return new (UInt())(this.g27(decoder));
      }
    }
    initMetadataForObject($, 'UIntSerializer', VOID, VOID, [KSerializer()]);
    UIntSerializerClass = $;
  }
  return UIntSerializerClass;
}
var UIntSerializer_instance;
function UIntSerializer_getInstance() {
  if (UIntSerializer_instance === VOID)
    new (UIntSerializer())();
  return UIntSerializer_instance;
}
var UByteSerializerClass;
function UByteSerializer() {
  if (UByteSerializerClass === VOID) {
    class $ {
      constructor() {
        UByteSerializer_instance = this;
        this.h27_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_1(ByteCompanionObject_instance));
      }
      h1m() {
        return this.h27_1;
      }
      i27(encoder, value) {
        var tmp = encoder.f1s(this.h27_1);
        // Inline function 'kotlin.UByte.toByte' call
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
        tmp.w1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.i27(encoder, value instanceof UByte() ? value.bu_1 : THROW_CCE());
      }
      j27(decoder) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.v1q(this.h27_1).m1q();
        return _UByte___init__impl__g9hnc4(this_0);
      }
      j1m(decoder) {
        return new (UByte())(this.j27(decoder));
      }
    }
    initMetadataForObject($, 'UByteSerializer', VOID, VOID, [KSerializer()]);
    UByteSerializerClass = $;
  }
  return UByteSerializerClass;
}
var UByteSerializer_instance;
function UByteSerializer_getInstance() {
  if (UByteSerializer_instance === VOID)
    new (UByteSerializer())();
  return UByteSerializer_instance;
}
var UShortSerializerClass;
function UShortSerializer() {
  if (UShortSerializerClass === VOID) {
    class $ {
      constructor() {
        UShortSerializer_instance = this;
        this.k27_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_2(ShortCompanionObject_instance));
      }
      h1m() {
        return this.k27_1;
      }
      l27(encoder, value) {
        var tmp = encoder.f1s(this.k27_1);
        // Inline function 'kotlin.UShort.toShort' call
        var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
        tmp.x1r(tmp$ret$0);
      }
      i1m(encoder, value) {
        return this.l27(encoder, value instanceof UShort() ? value.iv_1 : THROW_CCE());
      }
      m27(decoder) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.v1q(this.k27_1).n1q();
        return _UShort___init__impl__jigrne(this_0);
      }
      j1m(decoder) {
        return new (UShort())(this.m27(decoder));
      }
    }
    initMetadataForObject($, 'UShortSerializer', VOID, VOID, [KSerializer()]);
    UShortSerializerClass = $;
  }
  return UShortSerializerClass;
}
var UShortSerializer_instance;
function UShortSerializer_getInstance() {
  if (UShortSerializer_instance === VOID)
    new (UShortSerializer())();
  return UShortSerializer_instance;
}
//region block: exports
export {
  UByteSerializer_getInstance as UByteSerializer_getInstancefbeu9sjiaejx,
  UIntSerializer_getInstance as UIntSerializer_getInstance2tvkdh3aj09mk,
  ULongSerializer_getInstance as ULongSerializer_getInstance2vacfyt53ly2a,
  UShortSerializer_getInstance as UShortSerializer_getInstanceqqrojwqbi98b,
};
//endregion

//# sourceMappingURL=ValueClasses.mjs.map
